<div class="bar-wrapper">
  @if (title()) {
    <strong>{{ title() }}</strong>
  }
  <div class="outer-bar rounded" [class.shifted]="shifted() !== 0">
    <div
      class="annual-holder rounded-start"
      [style.width.%]="annualWrapper"
      [style.backgroundColor]="
        shiftedValue ? 'var(--jellyfish-600)' : 'transparent'
      "
    >
      <div class="annual rounded" [style.width.%]="annualValue"></div>
    </div>
    <div class="shifted-holder rounded" [style.width.%]="shiftedWrapper">
      <div class="shifted rounded-end"></div>
    </div>
  </div>

  <div class="legend">
    <div class="legend-item">
      <div class="legend-color annual-color"></div>
      <span>
        {{ dictionaryService.get('Annual') }}
        <strong>
          {{ leaveBalance }}
        </strong>
      </span>
    </div>
    <div class="legend-item">
      <div class="legend-color shifted-color"></div>
      <span>
        {{ dictionaryService.get('Shifted') }}

        <strong>
          {{ shiftedValue + ' / ' + shifted() }}
        </strong>
      </span>
    </div>
  </div>
</div>
